import React from "react";
import DataDisplay from "../../../components/dataDisplay/dataDisplay";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { api } from "./api";
import { useTableData } from "../hooks/useTableData";
import HandsonTable from "../../../components/handsonTable/handsonTable";
import columnCustomizer from "../../rawDataTableModule/smartComponents/columnCustomizer";
import "./StoreLogs.scss";

export const StoreLogsModule = () => {
  let {
    loading,
    headerInfo = [],
    tableInfo: { data = [], colHeaders = [], columns = [] } = {}
  } = useTableData({
    endpoint: api.getList
  });

  if (loading) return <LoadingAnimation />;

  const customizedColumns = columnCustomizer(colHeaders, columns);

  return data && data.length > 0 ? (
    <div id="store-logs" className="hot__flex">
      <div className="data-points">
        {headerInfo.map((dataPoint) => (
          <DataDisplay key={dataPoint[0]} label={dataPoint[0]} value={dataPoint[1]} />
        ))}
      </div>
      <HandsonTable
        showExportFileButton
        showExportCSV
        data={data}
        colHeaders={colHeaders}
        rowHeaders
        columns={customizedColumns}
        columnSorting
        filters
        dropdownMenu={
          data?.length > 1
            ? ["filter_by_condition", "---------", "filter_by_value", "filter_action_bar"]
            : false
        }
      />
    </div>
  ) : (
    <div className="error">No data available</div>
  );
};
